angular.
module("dx.webapp.exam").
factory("DxExternalToolSettings", function DxExternalToolSettingsFactory(
	$q,

	dxBitFlagsHelper,
	validationService,

	DX_EXTERNAL_TOOL_PERMISSION_TYPE
) {
	"use strict";

	function DxExternalToolSettings(data) {
		angular.extend(this, {
			id: 0,
			externalToolId: 0,
			title: "",
			landingPageUrl: "",
			requiredPermissions: -1,
		});

		if (data) {
			angular.extend(this, data);
		}
	}

	// Static variables
	DxExternalToolSettings.TITLE_MAX_LENGTH = 50;

	// Static methods
	DxExternalToolSettings.fromExternalTool = function fromExternalTool(data) {
		var settings = new DxExternalToolSettings();
		angular.extend(settings, {
			id: 0,
			externalToolId: data.id,
			title: data.title,
			landingPageUrl: data.landingPageIsEditable ? data.landingPageUrl : "",
			requiredPermissions: data.requiredPermissionsIsEditable ? data.requiredPermissions : -1,
		});
		return settings;
	};

	// Instance methods
	DxExternalToolSettings.prototype.isTitleValid = function isTitleValid() {
		return this.title.length > 0 && this.title.length <= DxExternalToolSettings.TITLE_MAX_LENGTH;
	};

	DxExternalToolSettings.prototype.isLandingPageValid = function isLandingPageValid(externalTool) {
		var deferred = $q.defer();
		if (this.isLandingPageMissing(externalTool)) {
			deferred.resolve(false);
		}

		if (this.landingPageUrl === "") {
			deferred.resolve(true);
		}

		validationService.isUrlValid(this.landingPageUrl).then(function onSuccess(isValid) {
			deferred.resolve(isValid);
		}, function onFail(err) {
			deferred.reject(err);
		});

		return deferred.promise;
	};

	DxExternalToolSettings.prototype.isLandingPageMissing = function isLandingPageMissing(externalTool) {
		return externalTool.landingPageIsEditable && !externalTool.landingPageUrl && !this.landingPageUrl;
	};

	DxExternalToolSettings.prototype.setLandingPageUrl = function setLandingPageUrl(url, externalTool) {
		var landingPageUrl = validationService.preprocessUrl(url);

		if (!externalTool.landingPageIsEditable || landingPageUrl === externalTool.landingPageUrl) {
			// Set the landing page URL to the default value (""), which indicates that
			// the original value stored on the organization-wide external tool was not modified.
			landingPageUrl = "";
		}

		this.landingPageUrl = landingPageUrl;
	};

	DxExternalToolSettings.prototype.isRequiredPermissionsModified = function isRequiredPermissionsModified() {
		return this.requiredPermissions !== -1;
	};

	DxExternalToolSettings.prototype.getRequiredPermissions = function getRequiredPermissions(externalTool) {
		// Determines whether the individual permissions are required based on the permission code.
		var requiredPermissions = [];

		// If the required permission settings weren't modified,
		// use the original value stored on the organization-wide external tool.
		var permissionCode = this.isRequiredPermissionsModified() ?
			this.requiredPermissions : externalTool.requiredPermissions;

		Object.values(DX_EXTERNAL_TOOL_PERMISSION_TYPE).forEach(function forEachPermissionType(permissionType) {
			if (dxBitFlagsHelper.isBitIncluded(permissionCode, permissionType)) {
				requiredPermissions.push(permissionType);
			}
		});

		return requiredPermissions;
	};

	DxExternalToolSettings.prototype.isRequiredPermissionsValid = function isRequiredPermissionsValid(externalTool) {
		return externalTool.requiredPermissionsIsEditable || !this.isRequiredPermissionsModified();
	};

	DxExternalToolSettings.prototype.setRequiredPermissions = function setRequiredPermissions(requiredPermissions, externalTool) {
		var permissionCode = getPermissionCode(requiredPermissions);

		if (!externalTool.requiredPermissionsIsEditable ||
			permissionCode === externalTool.requiredPermissions) {
			// Set the required permissions code to the default value (-1), which indicates that
			// the original value stored on the organization-wide external tool was not modified.
			this.requiredPermissions = -1;
		} else {
			this.requiredPermissions = permissionCode;
		}
	};

	// Auxiliary functions
	function getPermissionCode(requiredPermissions) {
		// Determines the permission code by applying bitwise operations on the permission values.
		var permissionCode = 0;

		requiredPermissions.forEach(function forEachPermissionType(permissionType) {
			permissionCode = dxBitFlagsHelper.addBit(permissionCode, permissionType);
		});

		return permissionCode;
	}

	return DxExternalToolSettings;
});
